import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import * as Yup from "yup";
import { Formik } from "formik";

import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
} from "@mui/material";
import { spacing } from "@mui/system";

import useAuth from "../../hooks/useAuth";
import axios from "../../utils/axios";
import { toast } from "react-toastify";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

function ResetPasswordOTP() {
  const navigate = useNavigate();
  const { resetPassword } = useAuth();

  return (
    <Formik
      initialValues={{
        email: "",
        otp: "",
        password: "",
        confirmPassword: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Deve ser um email valido")
          .max(255)
          .required("Email é obrigatorio"),
        otp: Yup.string().required("Codigo OTP é obrigatorio"),
        password: Yup.string()
          .min(6)
          .max(32)
          .required("Palavra-passe é obrigatoria"),
        confirmPassword: Yup.string()
          .transform((x) => (x === "" ? undefined : x))
          .required("Confirmação de palavra-passe é obrigatoria")
          .oneOf([Yup.ref("password")], "Palavras-passe devem coincidir"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          localStorage.clear();
          const response = await axios.post(
            "/auth/reset-otp",
            {
              email: values.email,
              password: values.password,
              otp: values.otp,
            },
            {
              headers: {
                Authorization: "",
              },
            }
          );
          if (response.status === 200) {
            alert(
              "A sua senha foi redefinida com sucesso \n Use a nova senha para entrar!"
            );
            navigate("/");
          }
        } catch (error: any) {
          const message = error || "Something went wrong";
          console.log(error);
          toast.error(message);
          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          <TextField
            type="email"
            name="email"
            label="Email"
            value={values.email}
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />
          <TextField
            type="text"
            name="otp"
            label="Codigo OTP enviado por email"
            value={values.otp}
            error={Boolean(touched.otp && errors.otp)}
            fullWidth
            helperText={touched.otp && errors.otp}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />
          <TextField
            type="password"
            name="password"
            label="Palavra-passe Nova"
            value={values.password}
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />{" "}
          <TextField
            type="password"
            name="confirmPassword"
            label="Confirme a Palavra-passe Nova"
            value={values.confirmPassword}
            error={Boolean(touched.confirmPassword && errors.confirmPassword)}
            fullWidth
            helperText={touched.confirmPassword && errors.confirmPassword}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            Submeter
          </Button>
        </form>
      )}
    </Formik>
  );
}

export default ResetPasswordOTP;
